namespace TabAurous.Purchase {
    export namespace PurchaseReturnMasterAPIService {
        export const baseUrl = '~/api/Purchase/PurchaseReturnAPI';

        export declare function Create(request: Serenity.SaveRequest<PurchaseReturnMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PurchaseReturnMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PurchaseReturnMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<PurchaseReturnMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "~/api/Purchase/PurchaseReturnAPI/Create",
            Update = "~/api/Purchase/PurchaseReturnAPI/Update",
            Delete = "~/api/Purchase/PurchaseReturnAPI/Delete",
            Retrieve = "~/api/Purchase/PurchaseReturnAPI/Retrieve",
            List = "~/api/Purchase/PurchaseReturnAPI/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PurchaseReturnMasterAPIService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
